import _classCallCheck from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module ui/label/labelview
 */
import View from '../view.js';
import { uid } from '@ckeditor/ckeditor5-utils';
import '../../theme/components/label/label.css';
/**
 * The label view class.
 */
var LabelView = /*#__PURE__*/function (_View) {
  _inherits(LabelView, _View);
  var _super = _createSuper(LabelView);
  /**
   * @inheritDoc
   */
  function LabelView(locale) {
    var _this;
    _classCallCheck(this, LabelView);
    _this = _super.call(this, locale);
    _this.set('text', undefined);
    _this.set('for', undefined);
    _this.id = "ck-editor__label_".concat(uid());
    var bind = _this.bindTemplate;
    _this.setTemplate({
      tag: 'label',
      attributes: {
        class: ['ck', 'ck-label'],
        id: _this.id,
        for: bind.to('for')
      },
      children: [{
        text: bind.to('text')
      }]
    });
    return _this;
  }
  return LabelView;
}(View);
export { LabelView as default };